export const LITHUANIAN_LEGAL_ENTITY_ID = "1";
export const LATVIAN_LEGAL_ENTITY_ID = "2";
export const ESTONIAN_LEGAL_ENTITY_ID = "3";